export var createNativeMediaRecorderConstructor = function createNativeMediaRecorderConstructor(window) {
  if (window === null) {
    return null;
  }
  return window.MediaRecorder === undefined ? null : window.MediaRecorder;
};